import React from 'react';
import { IconHistory, IconShare, IconCardEdit, IconMessageSquare } from 'src/presentations/components/atom/icons';
import Button from 'src/presentations/components/atom/button';
import { useAskFreya } from '../../pages/askFreya/AskFreyaContext';
import { AgentSelector } from '../../molecules/askFreya/AgentSelector';

export const AskFreyaHeader: React.FC = () => {
  const { startNewChat, messages, agents, selectedAgent } = useAskFreya();
  const hasMessages = messages.length > 0;
  const currentAgentTitle = agents.find((a) => a.name === selectedAgent)?.title ?? 'Ask Freya';

  return (
    <div className='flex items-center justify-between px-36 py-12 border-b border-neutral-20 bg-white'>
      <div className='flex items-center gap-12'>
        {hasMessages ? (
          <>
            <span className='text-neutral-40 text-20'>/</span>
            <div className='flex items-center gap-6'>
              <span className='text-neutral-40'>
                <IconCardEdit size={20} />
              </span>
              <h1 className='text-lg font-bold text-gray-800'>{currentAgentTitle}</h1>
            </div>
            <span className='text-neutral-40 text-20'>/</span>
            <AgentSelector />
          </>
        ) : (
          <>
            <h1 className='text-lg font-bold text-gray-800 flex items-center gap-2'>Ask Freya</h1>
            <AgentSelector />
            <span className='bg-[#E0F3E6] text-[#027A48] text-12 px-10 py-3 rounded-full font-medium border border-[#D1FADF]'>Beta</span>
          </>
        )}
      </div>
      <div className='flex items-center gap-3'>
        {hasMessages && (
          <>
            <Button variant='grey' size='medium' rounded='small' className='!px-16 !min-w-0 gap-8 !h-36' onClick={() => {}}>
              <IconHistory size={16} />
              History
            </Button>
            <Button variant='grey' size='medium' rounded='small' className='!px-16 !min-w-0 gap-8 !h-36' onClick={() => {}}>
              <IconShare size={16} />
              Share
            </Button>
            <Button
              variant='green_outline'
              size='medium'
              rounded='small'
              className='!px-16 !min-w-0 gap-8 !h-36 !bg-[#ECFDF3] hover:!bg-[#D1FADF] border-[#00A651]'
              onClick={startNewChat}
            >
              <IconMessageSquare size={16} />
              New Chat
            </Button>
          </>
        )}
      </div>
    </div>
  );
};
